import React, {FC, useContext, useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import {getCategory, updateProduct} from '../product-list/core/_requests'
import {Product} from '../product-list/core/_models'
import {useNavigate, useParams} from 'react-router-dom'
import {useAuth} from '../../../auth'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'

const imageUrl = process.env.REACT_APP_IMAGE_UPLOADS
const clinicDetailsSchema = Yup.object().shape({
  name: Yup.string().required('Employee name is required'),
  category_id: Yup.string().required('Category is required'),
})

type Props = {
  initialValues: Product
}
export const EditProduct: FC<Props> = ({initialValues}) => {
  const [data, setData] = useState<Product>(initialValues)
  const {showAlert} = useContext(AlertContext)
  const navigate = useNavigate()
  const {id} = useParams()
  const [category, setcategory] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [formImage, setFormImage] = useState<File | null>(null)

  //Image Target
  interface Event<T = EventTarget> {
    target: T
    // ...
  }

  //Image Handler
  const imageHandler = (e: Event<HTMLInputElement>) => {
    const reader = new FileReader()
    reader.onload = () => {
      if (reader.readyState === 2) {
        setData({
          ...data,
          profileNew: reader.result,
        })
      }
    }
    const files = e.target.files
    if (files) {
      setFormImage(files[0])
      reader.readAsDataURL(files[0])
    }
  }
  //get type
  const {currentUser} = useAuth()
  //
  const handleCategory = (e: any) => {
    formik.setFieldValue('category_id', e.target.value)
    const selectedOption = e.target.selectedOptions[0]
    const dataId = selectedOption.getAttribute('data-id')
    formik.setFieldValue('cat_mas_id', dataId)
  }
  const handleCancel = () => {
    // Navigate to the previous page
    navigate(-1)
  }

  const type = currentUser?.type
  //end get type
  const formik = useFormik<Product>({
    initialValues,
    validationSchema: clinicDetailsSchema,
    onSubmit: (values, actions) => {
      setLoading(true)
      setTimeout(() => {
        const updatedData = Object.assign(data, values)
        //updatedData.updatedBy = currentUser?.userId
        //Image and data Append to Form Data
        const formData = new FormData()
        //image append to formData
        if (formImage) {
          formData.append('profileNew', formImage)
        } else {
          const oldImage = initialValues.image // Assuming initialValues is defined elsewhere
          if (oldImage !== undefined) {
            formData.append('profileNew', oldImage)
          }
        }
        //append other data's in formData
        Object.entries(updatedData).forEach(([key, value]) => formData.append(key, value))

        updateProduct(formData, id).then((res) => {
          showAlert(res?.data?.Message, res?.data?.Code)
          navigate('/products', {replace: true})
        })
        setLoading(false)
      }, 1000)
    },
  })
  useEffect(() => {
    getCategory().then((res: any) => {
      setcategory(res.data.data)
    })
  }, [])

  
  return (
    <form onSubmit={formik.handleSubmit} noValidate className='form'>
      <div className='card mb-5 mb-xl-10 p-9'>
        {/** Company Info */}
        {/** Profile Image */}
        <div className='row mb-6'>
          <div className='col-lg-8'>
            <label className='col-lg-12 col-form-label fw-bold fs-6'>Product Picture</label>
            <div
              className='image-input image-input-outline'
              data-kt-image-input='true'
              style={{backgroundImage: `url(${initialValues?.image})`}}
            >
              {typeof data?.profileNew === 'string' ? (
                <div
                  className='image-input-wrapper w-125px h-125px'
                  style={{backgroundImage: `url(${data.profileNew})`}}
                ></div>
              ) : (
                <div
                  className='image-input-wrapper w-125px h-125px'
                  style={{
                    backgroundImage: `url(${initialValues?.image})`,
                  }}
                ></div>
              )}
              <label
                className='btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow'
                data-kt-image-input-action='change'
                data-bs-toggle='tooltip'
                data-bs-dismiss='click'
                title='Change Profile image'
              >
                <i className='bi bi-pencil-fill fs-7'></i>
                <input
                  type='file'
                  name='avatar'
                  onChange={imageHandler}
                  accept='.png, .jpg, .jpeg'
                />
              </label>
              {/* <!--end::Edit button--> */}
              {/* <!--begin::Remove button--> */}
              {data.profileNew && (
                <span
                  className='btn btn-icon btn-circle btn-color-muted btn-active-color-primary w-25px h-25px bg-body shadow'
                  data-kt-image-input-action='remove'
                  onClick={() => {
                    setData({
                      ...data,
                      profileNew: null,
                    })
                  }}
                  data-bs-toggle='tooltip'
                  data-bs-dismiss='click'
                  title='Remove Profile image'
                >
                  <i className='bi bi-x fs-2'></i>
                </span>
              )}
            </div>
            {data.image ? (
              ''
            ) : (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>Please upload profile</div>
              </div>
            )}
          </div>
        </div>
        <div className='row mb-6'>
          <div className='row'>
            <div className='col-lg-6 fv-row'>
              <label className='col-form-label required fw-bold fs-6'>Category</label>
              <select
                className='form-control form-control-lg form-control-solid'
                placeholder='Role'
                {...formik.getFieldProps('category_id')}
                onChange={(e) => handleCategory(e)}
              >
                <option value=''>Select a Category</option>
                {category.map((item: any, i: any) => {
                  return (
                    <option key={i} value={item.id} data-id={item.cat_mas_id}>
                      {item.name}
                    </option>
                  )
                })}
              </select>
              {formik.touched.category_id && formik.errors.category_id && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.category_id}</div>
                </div>
              )}
            </div>
            <div className='col-lg-6 fv-row'>
              <label className='col-form-label required fw-bold fs-6'>Name</label>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Enter Employee Name'
                {...formik.getFieldProps('name')}
              />
              {formik.touched.name && formik.errors.name && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>{formik.errors.name}</div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button type='button' className='btn btn-secondary ms-2' onClick={handleCancel}>
            Cancel
          </button>
          &nbsp;&nbsp;&nbsp;
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {!loading && 'Save Changes'}
            {loading && (
              <span className='indicator-progress' style={{display: 'block'}}>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
        </div>
      </div>
    </form>
  )
}

export default EditProduct
